import Swiper from './custom-swiper'
export * from './types/custom-swiper.types'

export default Swiper
